import { NativeModule, requireNativeModule } from "expo";

declare class ExpoNotificationServiceExtensionModule extends NativeModule {
  configureNotificationExtension(configJson: string): void;
  prefetchAvatar(url: string, id: string): Promise<void>;
  clearAvatarCache(): Promise<void>;
  validateSetup(samplePayloadJson?: string): Promise<string>;
}

export default requireNativeModule<ExpoNotificationServiceExtensionModule>(
  "ExpoNotificationServiceExtension"
);
